import { render, staticRenderFns } from "./CuentaCreate.vue?vue&type=template&id=01f9f90f&scoped=true"
import script from "./CuentaCreate.vue?vue&type=script&lang=js"
export * from "./CuentaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f9f90f",
  null
  
)

export default component.exports